import angular from 'angular';
import {
    IApontamentoTrabalhadorBase,
    IApontamentoTrabalhador,
    IApontamentoTrabalhadorCreate
} from '../models/apontamentostrabalhadores.model';

export class ApontamentosTrabalhadoresModalService {
    static $inject = [
        '$uibModal',
        '$rootScope',
        '$http',
        '$q',
        'nsjRouting',
    ];

    constructor(
        public $uibModal: ng.ui.bootstrap.IModalService,
        public $rootScope: angular.IRootScopeService & { session: any, nsjGlobals: any },
        public $http: angular.IHttpService,
        public $q: angular.IQService,
        public nsjRouting: any,
    ) { }

    open(
        subentity: IApontamentoTrabalhadorBase | {},
        mesreferencia: number,
        anoreferencia: number,
        apontamentostrabalhadores: IApontamentoTrabalhador[],
        visualizacao: boolean = false
    ) {
        return this.$uibModal.open({
            template: require('html-loader!./modal.html'),
            controller: 'ApontamentosTrabalhadoresModalController',
            controllerAs: '$ctrl',
            resolve: {
                entity: () => angular.copy(subentity),
                periodoApuracao: () => {
                    const constructor = {
                        estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento,
                        grupoempresarial: this.$rootScope.nsjGlobals.a.grupoempresarial,
                        tenant: this.$rootScope.nsjGlobals.a.tenant,
                        mesreferencia: mesreferencia,
                        anoreferencia: anoreferencia,
                    };
                    const url = this.nsjRouting.generate('faltastrabalhadores_periodoapuracao', constructor, true);
                    return this.$q<IApontamentoTrabalhadorCreate['periodoapuracao']>((resolve) => {
                        this.$http.get<IApontamentoTrabalhadorCreate['periodoapuracao']>(url).then(response => {
                            const periodoApuracao = {
                                datainicial: response.data.datainicial,
                                datafinal: response.data.datafinal
                            };
                            this.$rootScope.$broadcast('periodoapuracao_loaded', periodoApuracao);
                            resolve(periodoApuracao);
                        });
                    });
                },
                apontamentosTrabalhadores: () => angular.copy(apontamentostrabalhadores),
                visualizacao: () => angular.copy(visualizacao),
            },
            windowClass: 'nsj-modal-apontamentos-trabalhadores',
        });
    }
}
